import React from 'react';
import './style.scss';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { successUpdateMsg } from '../../../../../components/atoms/const';
import Button from '../../../../../components/molecules/buttons';
import {
  Clients, Delete as DeleteIcon, Pencil, Snack, SodaCan, ComboMachine, DollarSign,
} from '../../../../../components/atoms/icons';
import addCoffeeIcon from '../../../../../assets/icons/add-coffee.png';
import addVMIcon from '../../../../../assets/icons/add-vm.png';
import Modal from '../../../../../components/organisms/modals';
import useRenderVmCard from './hooks';
import getAllActiveRes from '../../../../../components/api/clients/getAllActive.json';
/* eslint-disable */
interface Props {
  vmData: typeof getAllActiveRes.data[0] | undefined;
  refetch: () => void
  isCoffee: boolean;
}

function RenderCard(props: Props) {
  const {
    vmData, refetch, isCoffee,
  } = props;
  const { show, modal, onNavigateToPlanogram, onNavigateToDex } = useRenderVmCard(refetch);

  const renderModalBody = () => {
    if (!modal.result) return 'Are you sure to remove this machine?';
    return successUpdateMsg.SUCCESS_DELETE_VM_MSG;
  };

  return (
    <div className="vm-card-container">
      <div className="d-flex justify-content-between align-items-center w-100 p-3">
        <div className="d-flex align-items-center">
          <Button.CircleIcon
            id="userCircleIcon"
            icon={<Clients width={15} />}
            className="bg-icon-color me-2"
          />
          <div className="fz-14">{vmData?.name ?? '-'}</div>
        </div>
        <Link to={`add/${vmData?.name?.replaceAll(' ', '-')}`}>
          <img src={isCoffee ? addCoffeeIcon : addVMIcon} alt="" width={35} style={{ marginBottom: '4px' }} />
        </Link>
      </div>
      <div style={{ height: '1px' }} className="bg-stroke w-100" />
      <Table borderless>
        <thead>
          <tr>
            <th style={{ width: '2.5%', border: 0 }}>&nbsp;</th>
            <th style={{ width: '26%' }} className="thead-content">
              <div className="my-2 fz-14 fw-bold">
                DEVICE ID
              </div>
            </th>
            <th style={{ width: '28%' }} className="thead-content">
              <div className="my-2 fz-14 fw-bold">
                LOCATION
              </div>
            </th>
            <th style={{ width: '24%' }} className="thead-content">
              <div className="my-2 fz-14 fw-bold">
                CONFIGURATION
              </div>
            </th>
            <th style={{ width: '17%' }} className="thead-content text-end">
              <div className="my-2 fz-14 fw-bold">
                ACTIONS
              </div>
            </th>
            <th style={{ width: '2.5%', border: 0 }}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {vmData?.vendingMachines?.map((data, i) => (
            <tr key={data?.id + data?.deviceId + i} className={`${(i % 2) && show.current ? 'tbody-content align-middle' : 'align-middle'} ${!show.current && i !== 0 ? 'd-none' : ''}`}>
              <td>&nbsp;</td>
              <td>
                <button
                  type="button"
                  onClick={() => onNavigateToPlanogram(data.id.toString())}
                  className="my-2 fz-14 fw-normal bg-transparent border-0 d-flex align-items-center"
                >
                  <div style={{ paddingRight: '5px' }}>
                    {<div style={{ paddingRight: '5px' }}>
                       {data?.type === 2 ? (
                         <SodaCan width={17} />
                       ) : data?.type === 1 ? (
                         <Snack width={21} />
                       ) : data?.type === 3 ? (
                         <ComboMachine width={21} />
                       ) : null}
                     </div>}
                  </div>
                  <div>
                    {data?.deviceId?.toString()}
                  </div>
                </button>
              </td>
              <td>
                <div className="my-2 fz-14 fw-normal location-text">
                  {data.location}
                </div>
              </td>
              <td>
                <div className="my-2 fz-14 fw-normal">
                  -
                </div>
              </td>
              <td>
                <div className="d-flex justify-content-end align-items-center">
                  <button
                    type="button"
                    className="border-0 bg-transparent"
                    onClick={() => onNavigateToDex(data.id.toString())}
                  >
                    <DollarSign width={26} />
                  </button>
                  <Modal.Default
                    cancelLabel="No"
                    submitLabel="Yes"
                    title="Remove Machine"
                    isLoading={modal.loading}
                    body={renderModalBody()}
                    result={modal.result}
                    onAfterResult={modal.after}
                    onSubmit={() => modal.handler(data.id.toString())}
                  >
                    <DeleteIcon width={18} />
                  </Modal.Default>
                  <Link to={`add/${vmData?.name?.replaceAll(' ', '-')}/${data.id}`} className="ms-2" style={{ marginTop: '2px' }}>
                    <Pencil width={20} />
                  </Link>
                </div>
              </td>
              <td>&nbsp;</td>
            </tr>
          ))}
          <tr>
            <td>&nbsp;</td>
            <td colSpan={4} className="border-top-table px-0">
              {vmData?.vendingMachines?.length ? (
                <div className={`d-flex justify-content-end ${vmData?.vendingMachines?.length > 1 ? '' : 'd-none'}`}>
                  <button type="button" className="button-show-hide" onClick={show.handler}>
                    <div>{show.current ? 'Show Less' : 'Show More'}</div>
                  </button>
                </div>
              ) : (
                <div className="text-center fz-14 mt-3">No Vending Machine</div>
              )}
            </td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}

export default React.memo(RenderCard);
